import { CalendarEntry, CalendarGroup } from 'owa-graph-schema';

import Calendar from '../store/schema/Calendar';
import CalendarFolder from 'owa-service/lib/contract/CalendarFolder';
import CalendarId from '../store/schema/CalendarId';
import { GroupAssociationNotificationPayload } from 'owa-group-association-notification';
import ItemId from 'owa-service/lib/contract/ItemId';
import { action } from 'satcheljs';

export const initializeCalendarsCacheInStore = action(
    'initializeCalendarsCacheInStore',
    (
        defaultCalendarEntry: Calendar,
        calendarEntries: { [key: string]: CalendarEntry },
        calendarGroups: { [key: string]: CalendarGroup },
        folderIdMapping: { [key: string]: CalendarId },
        calendarIdToChangeKeyMapping: { [key: string]: string }
    ) => {
        return {
            defaultCalendarEntry,
            calendarEntries,
            calendarGroups,
            folderIdMapping,
            calendarIdToChangeKeyMapping,
        };
    }
);

export const updateChangeKeyByCalendarItemId = action(
    'updateChangeKeyByCalendarItemId',
    (itemId: ItemId) => ({ itemId })
);

export const addToCalendarsCache = action('addToCalendarsCache', (calendarEntry: CalendarEntry) => {
    return {
        calendarEntry,
    };
});

export const addCalendarGroupToCalendarsCache = action(
    'addCalendarGroupToCalendarsCache',
    (calendarGroup: CalendarGroup) => {
        return {
            calendarGroup,
        };
    }
);

export const updateCalendarEntry = action(
    'updateCalendarEntry',
    (itemId: ItemId, calendarEntry: Partial<CalendarEntry>) => ({ itemId, calendarEntry })
);

export const updateCalendarFolder = action(
    'updateCalendarFolder',
    (calendar: Calendar, calendarFolder: Partial<CalendarFolder>) => ({ calendar, calendarFolder })
);

export const removeCalendarFromCalendarsCache = action(
    'removeCalendarFromCalendarsCache',
    (calendar: Calendar) => ({ calendar })
);

export const markCalendarEntryAsValid = action(
    'markCalendarEntryAsValid',
    (calendarEntry: CalendarEntry) => ({ calendarEntry })
);

export const calendarUpdated = action(
    'calendarUpdated',
    (calendarId: string, updates: Partial<Calendar>) => ({ calendarId, updates })
);

export const groupAssociationChanged = action(
    'groupAssociationChanged',
    (payload: GroupAssociationNotificationPayload) => ({ payload })
);

export const removeCalendarWithIDFromCalendarsCache = action(
    'removeCalendarWithIDFromCalendarsCache',
    (calendarId: string) => ({
        calendarId,
    })
);

export const updateCalendarGroup = action(
    'updateCalendarGroup',
    (groupId: string, userIdentity: string, calendarGroup: Partial<CalendarGroup>) => ({
        groupId,
        userIdentity,
        calendarGroup,
    })
);
